import {
  portableTextBlockSchema,
  sanityContentImageSchema,
  sanityContentVideoSchema,
  sanityThumbnailSchema,
} from "@modules/common/cms/sanityDto"
import { z } from "zod"

// Article Tags
export const articleTagSchema = z
  .union([
    z.literal("interview"),
    z.literal("tips"),
    z.literal("educational"),
    z.literal("community"),
    z.literal("events"),
    z.literal("sponsored"),
  ])
  .meta({ id: "articleTagSchema" })

// Article
export const articleSchema = z
  .object({
    _id: z.string(),
    source_id: z.string(),
    _type: z.literal("article"),
    _rev: z.string(),
    _createdAt: z.string(),
    source_createdAt: z.string(),
    _updatedAt: z.string(),
    title: z.string(),
    description: z.string(),
    author: z.string(),
    thumbnail: sanityThumbnailSchema,
    tag: articleTagSchema,
    content: z.array(z.union([portableTextBlockSchema, sanityContentImageSchema, sanityContentVideoSchema])),
    seo_id: z.object({
      current: z.string(),
      _type: z.string(),
    }),
  })
  .meta({ id: "articleSchema" })

export type ArticleThumbnailDto = z.infer<typeof sanityThumbnailSchema>

export type ArticleContentImageDto = z.infer<typeof sanityContentImageSchema>

export type PortableTextBlockDto = z.infer<typeof portableTextBlockSchema>

export type ArticleVideoDto = z.infer<typeof sanityContentVideoSchema>

export type ArticleDto = z.infer<typeof articleSchema>

export type ArticleTagDto = z.infer<typeof articleTagSchema>
